import LearnTranscriptDefault from './component.jsx'
export default LearnTranscriptDefault
